import React, { useState } from 'react';
import './ListViewInfo.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';


const ListViewInfo = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const taskDetails = location.state?.taskDetails || null;
  const [formData, setFormData] = useState({
    status:taskDetails?.status || '',
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const formatToLocalTime = (utcTimestamp) => {
  const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
  return new Date(utcTimestamp).toLocaleString(undefined, options);
};

const updateTaskk = async () => {
  try {
    // Check if status has changed
    if (taskDetails.status !== formData.status) {
      // Status has changed, update startTime or endTime based on the change
      const updatedFormData = { ...formData };

      if (formData.status === 'In-Process') {
        updatedFormData.startTime = taskDetails.startTime || new Date().toISOString();
      } else if (formData.status === 'Completed') {
        updatedFormData.startTime = taskDetails.startTime || new Date().toISOString();
        updatedFormData.endTime = new Date().toISOString(); // Store current time as endTime
      }

      // Update the task with the new form data
      const response = await axios.put(API_URL + `/taskss/${taskDetails.uuId}`, updatedFormData);

      if (response.status === 200) {
        console.log('Task updated successfully');
        navigate('/ListView');
      } else {
        console.error('Error updating task');
      }
    } else {
      // Status has not changed, update the task without modifying startTime or endTime
      const response = await axios.put(API_URL + `/taskss/${taskDetails.uuId}`, formData);

      if (response.status === 200) {
        console.log('Task updated successfully');
        navigate('/ListView');
      } else {
        console.error('Error updating task');
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const calculateTotalTime = () => {
  if (taskDetails.startTime) {
    const startTime = new Date(taskDetails.startTime);
    let endTime;

    // Check if endTime is a valid date
    if (taskDetails.endTime && !isNaN(new Date(taskDetails.endTime).getTime())) {
      endTime = new Date(taskDetails.endTime);
    } else {
      endTime = new Date(); // Use current time if endTime is invalid
    }

    const timeDifference = endTime - startTime;

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    const hours = Math.floor((timeDifference % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((timeDifference % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

    return `${days}d - ${hours}hrs - ${minutes}min - ${seconds}secs`;
  }

  return '00:00:00';
};



return( 
<div>
  <SideMenuBar></SideMenuBar>

<div class="content">
  <NewHeader></NewHeader>

  <div className='row2'>
    <h3 className='task_TaskViewInfo'>Task</h3>  
  </div>

  <div class="container_TaskViewInfo">
    <div class="main_column1_TaskViewInfo" >
        <h3 className='name_TaskViewInfo' >{taskDetails.assignee}</h3>

        <p className='title_column1_TaskViewInfo'>Task</p>
          <div className='divOf_label_column1_TaskViewInfo'>
            <label>{taskDetails.taskDetails}</label>
          </div>

        <p className='title_column1_TaskViewInfo'>Priority</p>
        <div className='divOf_label_column1_TaskViewInfo'>
            <label>{taskDetails.priority}</label>
          </div>
        <p className='title_column1_TaskViewInfo'>Category</p>
        <div className='divOf_label_column1_TaskViewInfo'>
            <label>{taskDetails.category}</label>
          </div>

        <p className='title_column1_TaskViewInfo'>Sub Category</p>
        <div className='divOf_label_column1_TaskViewInfo'>
            <label>{taskDetails.subCategory}</label>
          </div>

        <p className='title_column1_TaskViewInfo'>Status</p>
            <select className='select_of_TaskViewInfo' name='status'
                      value={formData.status}
                      onChange={handleInputChange}
                      disabled={formData.status === 'Completed'}>
                <option value="" selected disabled hidden>Select</option> 
                <option className='options_TaskViewInfo'>Pending</option>
                <option className='options_TaskViewInfo'>In-Process</option>
                <option className='options_TaskViewInfo'>Completed</option>
            </select>

        <p className='title_column1_TaskViewInfo'>Deadline</p>
          <div className='divOf_label_column1_TaskViewInfo'>
            <label>{taskDetails.deadline}</label>
          </div>
            {/*<input type="date" id="date" name="date" className='deadline_TaskViewInfo'/>*/}
 

        <p className='view_current_location_TaskViewInfo'><a href='/'> <b> Click Here to View Current Location</b></a></p>
    </div>

    <div class="main_column2_TaskViewInfo" >
        <h3 className='clientInfo_TaskViewInfo' >Client Info</h3>

        <p className='title_column2_TaskViewInfo'>Name</p>  
          <div className='divOf_label_column2_TaskViewInfo'>
            <label>{taskDetails.clientName}</label>
          </div>

        <p className='title_column2_TaskViewInfo'>Site Name</p>
          <div className='divOf_label_column2_TaskViewInfo'>
            <label>{taskDetails.siteName}</label>
          </div>

        <p className='title_column2_TaskViewInfo'>Phone No.</p>
          <div className='divOf_label_column2_TaskViewInfo'>
            <label>{taskDetails.siteMobile}</label>
          </div>

        <p className='title_column2_TaskViewInfo'>Email ID</p>
          <div className='divOf_label_column2_TaskViewInfo'>
            <label>{taskDetails.siteEmail}</label>
          </div>
        <p className='title_column2_TaskViewInfo'>Address</p>
          <div className='divOf_label_column2_TaskViewInfo'>
            <label>{taskDetails.siteAddress}</label>
          </div>
            
        <div className='pos_viewGallery'>
          <a href='/GalleryMedia' className='viewGallery_TaskViewInfo' > <b>View Gallery Here </b></a>
        </div>
    </div>
  </div>
  {/* {isIsFormOpenFor_ViewGallery && (
              <>
              <div className="overlay_TaskViewInfo" onClick={closeForm1}></div>
                <div className="popup-form_TaskViewInfo">
                  <span className="close_TaskViewInfo" onClick={closeForm1}>&times;</span>
                    <p className='gallery_TaskViewInfo'><b>Gallery</b></p><br/>
                      <form>
                        <div className='heading_TaskViewInfo'>
                            <a href='/' className='a_of_heading'><p className='media_TaskViewInfo'>&nbsp;Media&nbsp;</p></a>
                            <a href='/' className='a_of_heading'><p className='documents_TaskViewInfo'>&nbsp;Documents&nbsp;</p></a>
                        </div>     
                      </form>
                </div>
              </>
            )} */}

  <div class="row10_TaskViewInfo">
    <div class="column1_row10_TaskViewInfo">
        <p className='start_time_TaskViewInfo'>Start Time <b>{formatToLocalTime(taskDetails.startTime)}</b></p>
    </div>

    <div class="column2_row10_TaskViewInfo">
        <p className='end_time_TaskViewInfo'>End Time <b>{formatToLocalTime(taskDetails.endTime)}</b></p>
    </div>

    <div class="column3_row10_TaskViewInfo">
        <p className='total_time_TaskViewInfo'>Total Time <b>{calculateTotalTime()}</b></p>
    </div>
  </div>
  <button className='update_btn_input_TaskViewInfo' onClick={updateTaskk}>Update</button>
  <br /><br /><br />
</div>

</div>
 )
}

export default ListViewInfo;